import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

export enum SaveAction {
  Override = 'override',
  SaveAsNew = 'saveAsNew'
}

export interface EditorSaveResult {
  save: SaveAction;
  name?: string;
  share?: boolean;
}

export interface EditorSaveDialogData {
  defaultNewName: string;
  isDefault: boolean;
  canManage: boolean;
  availableTemplates: string[];
}

@Component({
    standalone: true,
    selector: 'app-editor-save-dialog',
    imports: [FormsModule, SharedModule],
    templateUrl: './editor-save-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./editor-save-dialog.component.scss']
})
export class EditorSaveDialogComponent implements OnInit {
  readonly SaveAction = SaveAction;

  saveAction: SaveAction | null = null;
  newName = '';
  share = false;

  get isNameDuplicate(): boolean {
    return this.saveAction === SaveAction.SaveAsNew &&
      this.data.availableTemplates.some(n => n.toLowerCase() === this.newName.trim().toLowerCase());
  }

  get isConfirmEnabled(): boolean {
    if (!this.saveAction) return false;
    if (this.saveAction === SaveAction.SaveAsNew) {
      return !!this.newName.trim() && !this.isNameDuplicate;
    }
    return true;
  }

  constructor(
    private dialogRef: MatDialogRef<EditorSaveDialogComponent, EditorSaveResult | null>,
    @Inject(MAT_DIALOG_DATA) public data: EditorSaveDialogData
  ) {}

  ngOnInit(): void {
    this.newName = this.data.defaultNewName;
  }

  selectSave(action: SaveAction): void {
    if (action === SaveAction.Override && !this.data.canManage) return;
    this.saveAction = this.saveAction === action ? null : action;
  }

  confirm(): void {
    if (!this.isConfirmEnabled || !this.saveAction) return;
    const result: EditorSaveResult = {
      save: this.saveAction,
      name: this.saveAction === SaveAction.SaveAsNew ? this.newName.trim() : undefined,
      share: this.saveAction === SaveAction.SaveAsNew ? this.share : undefined
    };
    this.dialogRef.close(result);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
